import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=ddd02b62&"
import script from "./sign-up.vue?vue&type=script&lang=js&"
export * from "./sign-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormField: require('/server/itg-custom/staging/front/components/FormField.vue').default,UiBtn: require('/server/itg-custom/staging/front/components/UiBtn.vue').default,UiSection: require('/server/itg-custom/staging/front/components/UiSection.vue').default})
